import { render } from "./CustomerCreateComponent.vue?vue&type=template&id=24032a0e"
import script from "./CustomerCreateComponent.vue?vue&type=script&lang=js"
export * from "./CustomerCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/customers/CustomerCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24032a0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24032a0e', __exports__)) {
    api.reload('24032a0e', __exports__)
  }
  
  module.hot.accept("./CustomerCreateComponent.vue?vue&type=template&id=24032a0e", () => {
    api.rerender('24032a0e', render)
  })

}


export default __exports__